require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/old_vendors/moment/pl.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/old_vendors/moment/pl.legacy.js
// module id = 589
// module chunks = 31